export default {
      id: "icon-prev-usage",
      viewBox: "0 0 13 23",
      url: __webpack_public_path__ + "img/icons.c2f64a3b.svg#icon-prev",
      toString: function () {
        return this.url;
      }
    }